import React from 'react';
import { FormattedMessage } from 'react-intl';
import { InlineMessage } from 'ui-components/components/inline-message';
import { Input } from 'ui-components/components/input';
import { InputLabel } from '../../../../../../address/input-label';
import messages from './supplier-modal.messages';
import style from './supplier-modal.styles.module.less';

/**
 * Input field component for supplier form
 * @param {object} props - Component props
 * @param {string} props.fieldName - The name of the field
 * @param {import('react-intl').MessageDescriptor} props.label - The label message descriptor
 * @param {boolean} [props.required] - Whether the field is required
 * @param {boolean} props.hasError - Whether the field has an error
 * @param {() => void} props.onBlur - Function to call on field blur
 * @param {() => void} props.onChange - Function to call on field change
 * @param {string} props.fieldValue - The field value
 * @returns {JSX.Element} The rendered input field component
 */
const SupplierInputField = ({ fieldName, label, required = false, hasError, onBlur, onChange, fieldValue }) => (
  <div className={style['modal-supplier-col-2']}>
    <InputLabel hasError={hasError} labelFor={`${fieldName}-input`} required={required}>
      <FormattedMessage {...label} />
    </InputLabel>
    <Input
      hasError={hasError}
      id={`${fieldName}-input`}
      name={fieldName}
      onBlur={() => onBlur(fieldName)}
      onChange={(value) => onChange(fieldName, value)}
      value={fieldValue}
    />
    {hasError && (
      <InlineMessage type='error'>
        <FormattedMessage {...messages[`${fieldName}Required`]} />
      </InlineMessage>
    )}
  </div>
);

export default SupplierInputField;
